import { useLang } from "@/context/LanguageContext";
import { media } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const Gallery = () => {
  const { t } = useLang();
  const cats = t.gallery.categories;

  const items = [
    { key: "living", src: media.gallery.living, span: "row-span-2" },
    { key: "camera", src: media.gallery.camera, span: "" },
    { key: "tessili", src: media.gallery.tessili, span: "" },
    { key: "bagno", src: media.gallery.bagno, span: "row-span-2" },
    { key: "lenzuola", src: media.gallery.lenzuola, span: "" },
    { key: "tende", src: media.gallery.tende, span: "" },
    { key: "cuscini", src: media.gallery.cuscini, span: "" },
    { key: "complementi", src: media.gallery.complementi, span: "row-span-2" },
  ];

  return (
    <section id="gallery" data-testid="gallery" className="relative bg-[#FAFAF7] py-24 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14">
          <Reveal>
            <p className="text-sm tracking-luxe uppercase text-[#A39B8E] mb-6">{t.gallery.kicker}</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              {t.gallery.title}
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[200px] md:auto-rows-[240px] gap-3 md:gap-4">
          {items.map((it, i) => (
            <Reveal
              key={it.key}
              delay={(i % 4) * 0.06}
              className={`gallery-item group relative overflow-hidden cursor-pointer ${it.span}`}
            >
              <img
                src={it.src}
                alt={cats[it.key]}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="absolute inset-x-0 bottom-0 p-5 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                <span className="text-white font-display text-2xl">{cats[it.key]}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
